import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { get } from '../../../../../Model/Network/Config/Axios';
import { handleError } from '../../../../Common/fToast/ToastCallback';
import { DEV_MODE } from '../../../../../Model/Network/Api/config';

const useTdsList = ({ vendorId, vendor, tdsSlabs, entityId }) => {

	const [tdsList, setTdsList] = useState([]);
	const [loader, setLoader] = useState(true);

	const { onlyGlobalTdsMaster, tdsEntitySegregated, vcTdsMasterVisibility } = useSelector((state) => state.auth.config.plugins);

	let Dev_Mode_Check = (DEV_MODE || window.location.href.includes("localhost")) // dev mode check needs to be removed once it is done from BE on prod
	const individualHufTypes = vendor && vendor.pan && ["P", "H", "B"].includes(vendor.pan.charAt(3));

	let fetchAllTds = () => {
		if (onlyGlobalTdsMaster) {
			if (vcTdsMasterVisibility) {
				get('vendor/config/tds/getAllVcTdsMaster', (e, r) => {
					if (r && r.tds && r.tds.length) {
						let items = [];
						if (tdsSlabs) {
							items = r.tds.filter(item => _.includes(tdsSlabs, item.tdsMasterId))
						}
						setTdsList(items.map(val => ({
							id: val.tdsMasterId,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate : val.otherRate,
							individualHufRate: val.individualHufRate,
							otherRate: val.otherRate,
							type: 'master',
							tdsMaster: val.tdsMasterId
						})))
					}
					if (e) handleError(e)
					setLoader(false);
				})
			}
			else {
				get(`vendor/config/tds/allTdsMaster`, (e, r) => {
					if (r) {
						let items = [];
						if (tdsSlabs) {
							items = r.tds.filter(item => _.includes(tdsSlabs, item.id))
						}
						setTdsList(items.map(val => ({
							id: val.id,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate : val.otherRate,
							individualHufRate: val.individualHufRate,
							otherRate: val.otherRate,
							type: 'master'
						})))
					}
					if (e) handleError(e)
					setLoader(false)
				})
			}
		} else {
			get(`vendor/contacts/${vendorId}/details`, (e1, r1) => {
				if (r1) {
					get(`/vendor/config/tds/all`, (e, r) => {
						if (r) {
							let items = r1.config.tdsIds.length ? r.tds.filter(item => _.includes(r1.config.tdsIds, item.id)) : r.tds;
							setTdsList(items.map(val => ({
								id: val.id,
								label: val.code,
								des: val.description,
								tax: val.tax
							})))
						}
						if (e) handleError(e)
						setLoader(false);
					})
				} else {
					if (e1) handleError(e1)
					setLoader(false);
				}
			})
		}
	}

	useEffect(() => {
		if (Dev_Mode_Check && tdsEntitySegregated && entityId) {
			get(`vendor/config/tds/${entityId}/allTdsMasterV2`, (e, r) => {
				if (r) {
					if (r.tds && r.tds.length) {
						setTdsList(r.tds.map(val => ({
							id: val.id,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate : val.otherRate,
							individualHufRate: val.individualHufRate,
							otherRate: val.otherRate
						})))
						setLoader(false);
					}
					else {
						fetchAllTds()
					}
				}
				else if (e) {
					handleError(e)
					setLoader(false);
				}
			})
		}
		else {
			fetchAllTds()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return { tdsList, loader };
}

export default useTdsList;
